export const COUNTRY_ISD_CODES = [
  { code: '+91', label: 'India (+91)', minLength: 10, maxLength: 10 },
  { code: '+1', label: 'United States/Canada (+1)', minLength: 10, maxLength: 10 },
  { code: '+7', label: 'Russia/Kazakhstan (+7)', minLength: 10, maxLength: 10 },
  { code: '+20', label: 'Egypt (+20)', minLength: 10, maxLength: 10 },
  { code: '+27', label: 'South Africa (+27)', minLength: 9, maxLength: 9 },
  { code: '+30', label: 'Greece (+30)', minLength: 10, maxLength: 10 },
  { code: '+31', label: 'Netherlands (+31)', minLength: 9, maxLength: 9 },
  { code: '+32', label: 'Belgium (+32)', minLength: 8, maxLength: 9 },
  { code: '+33', label: 'France (+33)', minLength: 9, maxLength: 9 },
  { code: '+34', label: 'Spain (+34)', minLength: 9, maxLength: 9 },
  { code: '+36', label: 'Hungary (+36)', minLength: 9, maxLength: 9 },
  { code: '+39', label: 'Italy (+39)', minLength: 9, maxLength: 10 },
  { code: '+40', label: 'Romania (+40)', minLength: 9, maxLength: 9 },
  { code: '+41', label: 'Switzerland (+41)', minLength: 9, maxLength: 9 },
  { code: '+43', label: 'Austria (+43)', minLength: 10, maxLength: 13 },
  { code: '+44', label: 'United Kingdom (+44)', minLength: 10, maxLength: 10 },
  { code: '+45', label: 'Denmark (+45)', minLength: 8, maxLength: 8 },
  { code: '+46', label: 'Sweden (+46)', minLength: 7, maxLength: 10 },
  { code: '+47', label: 'Norway (+47)', minLength: 8, maxLength: 8 },
  { code: '+48', label: 'Poland (+48)', minLength: 9, maxLength: 9 },
  { code: '+49', label: 'Germany (+49)', minLength: 10, maxLength: 11 },
  { code: '+51', label: 'Peru (+51)', minLength: 9, maxLength: 9 },
  { code: '+52', label: 'Mexico (+52)', minLength: 10, maxLength: 10 },
  { code: '+54', label: 'Argentina (+54)', minLength: 10, maxLength: 10 },
  { code: '+55', label: 'Brazil (+55)', minLength: 10, maxLength: 11 },
  { code: '+60', label: 'Malaysia (+60)', minLength: 9, maxLength: 10 },
  { code: '+61', label: 'Australia (+61)', minLength: 9, maxLength: 9 },
  { code: '+62', label: 'Indonesia (+62)', minLength: 9, maxLength: 11 },
  { code: '+63', label: 'Philippines (+63)', minLength: 10, maxLength: 10 },
  { code: '+64', label: 'New Zealand (+64)', minLength: 8, maxLength: 10 },
  { code: '+65', label: 'Singapore (+65)', minLength: 8, maxLength: 8 },
  { code: '+66', label: 'Thailand (+66)', minLength: 9, maxLength: 9 },
  { code: '+81', label: 'Japan (+81)', minLength: 10, maxLength: 10 },
  { code: '+82', label: 'South Korea (+82)', minLength: 9, maxLength: 10 },
  { code: '+84', label: 'Vietnam (+84)', minLength: 9, maxLength: 10 },
  { code: '+86', label: 'China (+86)', minLength: 11, maxLength: 11 },
  { code: '+90', label: 'Turkey (+90)', minLength: 10, maxLength: 10 },
  { code: '+92', label: 'Pakistan (+92)', minLength: 10, maxLength: 10 },
  { code: '+93', label: 'Afghanistan (+93)', minLength: 9, maxLength: 9 },
  { code: '+94', label: 'Sri Lanka (+94)', minLength: 9, maxLength: 9 },
  { code: '+95', label: 'Myanmar (+95)', minLength: 7, maxLength: 10 },
  { code: '+960', label: 'Maldives (+960)', minLength: 7, maxLength: 7 },
  { code: '+971', label: 'UAE (+971)', minLength: 9, maxLength: 9 },
  { code: '+972', label: 'Israel (+972)', minLength: 9, maxLength: 9 },
  { code: '+973', label: 'Bahrain (+973)', minLength: 8, maxLength: 8 },
  { code: '+974', label: 'Qatar (+974)', minLength: 8, maxLength: 8 },
  { code: '+975', label: 'Bhutan (+975)', minLength: 8, maxLength: 8 },
  { code: '+976', label: 'Mongolia (+976)', minLength: 8, maxLength: 8 },
  { code: '+977', label: 'Nepal (+977)', minLength: 10, maxLength: 10 },
  { code: '+880', label: 'Bangladesh (+880)', minLength: 10, maxLength: 10 },
  { code: '+886', label: 'Taiwan (+886)', minLength: 9, maxLength: 9 },
];

export const getPhoneRuleByIsd = (isdCode) => {
  return COUNTRY_ISD_CODES.find((entry) => entry.code === isdCode) || { minLength: 6, maxLength: 15 };
};
